// var agent = window.navigator.userAgent.toLowerCase()
let version = '1.0'
export default {
  getVersion() {
    return version
  },
  sendMessage(msg) {
	 uni.postMessage({
		data: msg
	 });
  },
  callback(msg) {
    uni.postMessage({
      data: msg
    });
    return null; //旧版有个返回值但是没用它，为了兼容也直接返回null。
  }
}



// WEBPACK FOOTER //
// ./utils/mobileController.js